var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.79287 15.1216L6.7966 15.1234C6.92587 15.1808 7.0738 15.181 7.20307 15.1236L7.20553 15.1224C7.22067 15.1155 7.25793 15.0984 7.2802 15.088C7.32753 15.0657 7.3956 15.033 7.4814 14.9902C7.65293 14.9044 7.89587 14.7775 8.18647 14.6107C8.7664 14.2777 9.542 13.7825 10.3201 13.1341C11.8595 11.8512 13.5 9.89051 13.5 7.33331C13.5 3.74346 10.5899 0.833313 7 0.833313C3.41015 0.833313 0.5 3.74346 0.5 7.33331C0.5 9.89051 2.14051 11.8512 3.67991 13.1341C4.45802 13.7825 5.23359 14.2777 5.81353 14.6107C6.10413 14.7775 6.34707 14.9044 6.5186 14.9902C6.60227 15.032 6.742 15.0977 6.79287 15.1216ZM7 4.66665C5.52724 4.66665 4.33333 5.86055 4.33333 7.33331C4.33333 8.80605 5.52724 9.99998 7 9.99998C8.47273 9.99998 9.66667 8.80605 9.66667 7.33331C9.66667 5.86055 8.47273 4.66665 7 4.66665Z",
    fill: "#7F818D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation2);
export default __webpack_public_path__ + "static/media/location-2.dfa534d35893153c48a68b94f1b9f510.svg";
export { ForwardRef as ReactComponent };